import { communityStats, forumPosts } from "@/mocks/home";

export default function Hero() {
  const hotPost = forumPosts[0];

  return (
    <section className="relative overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-64 w-64 rounded-full bg-accent-100/50 blur-3xl" />

      <div className="relative mx-auto grid max-w-[1280px] grid-cols-1 gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-12 lg:gap-12 lg:py-20">
        <div className="animate-fade-up lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500 animate-pulse-dot" />
            玩家交流 · 一站搞定
          </span>

          <h1 className="mt-5 font-heading text-3xl leading-tight text-foreground-950 md:text-[2.75rem] md:leading-[1.15]">
            模型手办怎么选？
            <br />
            看<span className="text-primary-600">周边测评</span>、
            逛<span className="text-primary-600">资料库</span>、
            泡<span className="text-primary-600">论坛</span>，
            <br className="hidden md:block" />
            玩家交流一站搞定
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            想入手心仪的模型手办却不知从何选起？这里汇集真实玩家的周边测评、详尽的资料库与热闹的论坛讨论，
            无论你是刚入坑的新手还是收藏多年的老玩家，都能找到实用参考，也能碰上聊得来的同好。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#guide"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-compass-3-line text-base" />
              从选品开始
            </a>
            <a
              href="#download"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-download-2-line text-base" />
              下载 78动漫 App
            </a>
            <a
              href="#forum"
              className="flex items-center justify-center gap-1.5 whitespace-nowrap px-2 py-3 text-sm text-foreground-600 transition-colors hover:text-primary-700"
            >
              先去论坛逛逛
              <i className="ri-arrow-right-line" />
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-4">
            {communityStats.map((stat) => (
              <div key={stat.id} className="bg-background-50 px-4 py-3.5">
                <dt className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                  {stat.value}
                </dt>
                <dd className="mt-0.5 text-xs text-foreground-500">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="animate-fade-up lg:col-span-5" style={{ animationDelay: "120ms" }}>
          <div className="relative ml-auto w-full max-w-md">
            <div className="relative h-[300px] w-full overflow-hidden rounded-xl border border-background-200 md:h-[380px]">
              <img
                src="https://readdy.ai/api/search-image?query=Neat%20studio%20shelf%20displaying%20collectible%20anime%20figures%20and%20model%20kits%20in%20warm%20neutral%20tones%2C%20soft%20natural%20light%2C%20clean%20minimal%20background%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20restrained%20muted%20palette%2C%20high%20detail&width=800&height=1000&seq=78dm-hero-shelf&orientation=portrait"
                alt="78动漫玩家收藏的模型手办展示架"
                title="78动漫 模型手办 收藏展示"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent" />
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-xs text-background-50/80">今日同好晒物</p>
                <p className="mt-0.5 font-heading text-base font-bold text-background-50">
                  收藏墙 · 八年积累
                </p>
              </div>
            </div>

            <div className="mt-3 rounded-xl border border-background-200 bg-background-50 p-4">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span className="flex h-4 w-4 items-center justify-center rounded-full bg-accent-500 text-[10px] text-background-50">
                  <i className="ri-fire-line" />
                </span>
                论坛实时热帖
                <span className="ml-auto">{hotPost.time}</span>
              </div>
              <a
                href="#forum"
                className="mt-2.5 block font-heading text-sm font-bold leading-snug text-foreground-900 transition-colors hover:text-primary-700"
              >
                {hotPost.title}
              </a>
              <div className="mt-2.5 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span className="rounded-full bg-background-100 px-2 py-0.5 text-foreground-700">
                  {hotPost.board}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line" />
                  {hotPost.replies} 回复
                </span>
                <span>{hotPost.author}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-100/60">
        <div className="mx-auto flex max-w-[1280px] items-center gap-4 overflow-hidden px-4 py-2.5 md:px-6">
          <span className="flex shrink-0 items-center gap-1.5 text-xs font-medium text-primary-700">
            <i className="ri-line-chart-line" />
            热议
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee gap-8 text-xs text-foreground-600">
              {[...Array(2)].map((_, dup) => (
                <div key={dup} className="flex shrink-0 gap-8">
                  {[
                    "初音未来 交响乐 Ver. 测评出炉，涂装获一致好评",
                    "EVA 初号机 RG 现货补货中，库存有限",
                    "寿屋五条悟预售延期，玩家集中讨论",
                    "新手入坑必看：1000 元内手办清单更新",
                    "资料库本周新增 320 条新品条目",
                  ].map((item) => (
                    <span key={`${dup}-${item}`} className="flex shrink-0 items-center gap-2">
                      <i className="ri-price-tag-3-line text-accent-500" />
                      {item}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}